import _typeof from "@babel/runtime/helpers/typeof";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import styles from "./styles.pcss";
import { FlexItem } from "./FlexItem";
var cn = classNames.bind(styles);
export var Flex = function Flex(_ref) {
  var children = _ref.children,
    align = _ref.align,
    justifyContent = _ref.justifyContent,
    alignItems = _ref.alignItems,
    gap = _ref.gap,
    wrap = _ref.wrap,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: cn('container', align && "align--".concat(align), gap && "gap--".concat(gap), wrap && "wrap--".concat(wrap), alignItems && "alignItems--".concat(alignItems), className),
    style: {
      justifyContent: justifyContent
    },
    "data-t-id": "common-Flex"
  }, React.Children.map(children, function (child, index) {
    var _child$props, _child$props2;
    return !child || child.type === Flex.Item ? child : /*#__PURE__*/React.createElement(Flex.Item, {
      align: (_child$props = child.props) === null || _child$props === void 0 ? void 0 : _child$props.align,
      flex: (_child$props2 = child.props) === null || _child$props2 === void 0 ? void 0 : _child$props2.flex,
      key: +index
    }, _typeof(child) === 'object' ? /*#__PURE__*/React.cloneElement(child, {
      flex: undefined
    }) : child);
  }));
};
Flex.Item = FlexItem;
Flex.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node,
  align: PropTypes.oneOf(['left', 'right']),
  wrap: PropTypes.oneOf(['wrap', 'nowrap', 'wrap-reverse']),
  alignItems: PropTypes.oneOf(['center', 'start', 'end', 'baseline', 'stretch']),
  gap: PropTypes.oneOf(['5xl', '4xl', '3xl', '2xl', 'xl', 'l', 'm', 's', 'xs', '2xs', '3xs', '4xs']),
  justifyContent: PropTypes.string,
  className: PropTypes.string
} : {};